module.exports = __webpack_public_path__ + "static/media/X.774746d0.svg";